<template>
  <v-dialog
    v-model="props.dialog_parent"
    max-width="750px"
    v-on:click:outside="closeDialogChild"
  >
    <v-card>
      <v-card-title class="bg-blue-darken-2">
        <h2 class="text-h4 text-center">Dotación de Sable</h2>
      </v-card-title>

      <v-card-title>
        <span class="text-h5">
          <v-icon
            icon="mdi-pencil"
            size="samll"
            color="blue-darken-2 as-scale"
          ></v-icon>
          {{ props.formTitleParent }}
        </span>
      </v-card-title>

      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="props.registro_parent.carnet"
              color="cyan-darken-2"
              label="Carnet"
              :rules="[
                () => !!props.registro_parent.carnet || required_message,
                (v) =>
                  !!/^\d+$/.test(v) ||
                  'El Numero de identidad solo debe contener caracteres numéricos.',
              ]"
              :error-messages="getValidationErrors('carnet')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="blue" @click="buscarNombre">Buscar</v-btn>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="props.registro_parent.nombreCompletolimpio"
              color="cyan-darken-1"
              label="Nombre"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.carnet"
              color="cyan-darken-2"
              label="Carnet"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="props.registro_parent.codigo_persona"
              color="cyan-darken-2"
              label="Codigo Persona"
              variant="outlined"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
              <v-select
                v-model="props.registro_parent.descripcion"
                :items="sables"
                density="compact"
                label="Sable"
              ></v-select>
            </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="props.registro_parent.marca"
              color="cyan-darken-2"
              label="Marca"
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="props.registro_parent.observaciones"
              color="cyan-darken-2"
              label="Observaciones"
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="props.registro_parent.gestion_dotacion"
              :items="items"
              density="compact"
              label="Gestión Dotacion"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <label for="selectOption"
              >Seleccione el Pais de Procedencia:
            </label>
            <select
              v-model="props.registro_parent.procedencia"
              class="form-select"
              id="selectOption"
              aria-label="Default select example"
            >
              <option
                v-for="item in optionsprocedencia"
                :key="item.descripcion"
                :value="item.descripcion"
              >
                {{ item.codigo_origen }} - {{ item.descripcion }}
              </option>
            </select>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="outlined" @click="closeDialogChild()" color="red">
          <v-icon icon="mdi-file-cancel-outline"></v-icon>&nbsp;Cancelar
        </v-btn>
        <v-btn color="cyan-darken-1" variant="outlined" @click="saveChild()">
          <v-icon icon="mdi-content-save-check-outline"></v-icon>&nbsp;Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import Busqueda from "@/services/Personal";
import Selects from "@/services/Selects";

export default defineComponent({
  props: [
    "dialog_parent",
    "registro_parent",
    "formTitleParent",
    "errors_validate_parent",
  ],
  emits: ["closeDialogParent", "saveParent"],
  data() {
    return {
      items: [
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
      ],
      sables: [
        "SABLE DORADO",
        "SABLE PLATEADO",
      ],
      optionsprocedencia: [],
    };
  },
  async mounted() {
    const selectprocedencia = new Selects(); //--4
    const dataprocedencia = await selectprocedencia.loadDataProcedencia2(); //--4
    this.optionsprocedencia = dataprocedencia; //--4
    console.log("Datos cargados de procedencia:", dataprocedencia); //--4
  },
  methods: {
    async buscarNombre() {
      try {
        const numeroCarnet = this.props.registro_parent.carnet;
        console.log("Número de Carnet:", numeroCarnet);

        const busqueda = new Busqueda();
        const resultadoBusqueda = await busqueda.busquedaporci(numeroCarnet);
        console.log("Resultado de la búsqueda:", resultadoBusqueda);
        //resultadoBusqueda && resultadoBusqueda.status && resultadoBusqueda.records &&
        if (
          resultadoBusqueda &&
          resultadoBusqueda.status &&
          resultadoBusqueda.records &&
          resultadoBusqueda.records.data &&
          resultadoBusqueda.records.data.nombre
        ) {
          this.props.registro_parent.nombreCompletolimpio =
            resultadoBusqueda.records.data.nombre;
          this.props.registro_parent.codigo_persona =
            resultadoBusqueda.records.data.codigo_persona;
          console.log(
            "Este es el nombre completo",
            this.props.registro_parent.nombreCompletolimpio
          );
        } else {
          alert(
            "Carnet no encontrado en la base de datos o no hay un nombre disponible en la respuesta"
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  setup(props, { emit }) {
    const closeDialogChild = () => {
      emit("closeDialogParent");
    };
    const saveChild = () => {
      emit("saveParent");
    };
    return { props, closeDialogChild, saveChild };
  },
  computed: {
    getValidationErrors() {
      return function (property) {
        if (
          this.props.errors_validate_parent &&
          this.props.errors_validate_parent[property]
        ) {
          return this.props.errors_validate_parent[property][0];
        }
        return "";
      };
    },
  },
});
</script>
